export const SkeletonArticleCard = () => {
	return (
		<div className="flex justify-center">
			<div className="flex w-full max-w-[382px] flex-col rounded-lg bg-white shadow-md sm:rounded-none sm:shadow-transparent">
				<div className="px-4 pt-4 sm:p-0">
					<div className="aspect-[382/152] animate-pulse overflow-hidden rounded-lg bg-gray-200 sm:rounded-2xl" />
				</div>
				<div className="px-4 pb-2 sm:px-0 sm:pb-0">
					<div className="my-2 h-4 w-1/3 animate-pulse rounded-lg bg-gray-200" />
					<div className="mt-2 h-6 w-full animate-pulse rounded-lg bg-gray-200" />
				</div>
			</div>
		</div>
	);
};
